// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1293":"027a3d2d","9576":"027a3d2d"}[chunkId] + ".chunk.css";
};